export default "__VITE_ASSET__CUHDIgyg__"